(function() {
	'use strict';

	angular.module('claimsApp').controller('ClaimAdjustInfoHistoryController',
			ClaimAdjustInfoHistoryController);

	ClaimAdjustInfoHistoryController.$inject = [ '$scope', '$state', '$log','$resource','NgTableParams','Upload','authExpiredInterceptor','$timeout','$base64','ClaimAdjustInfo','CLAIM_TYPE','$filter','FORMAT_DATE','$window','GLOBAL_URL','ClaimRegistration','$stateParams','MyTask','$uibModal' ];

	function ClaimAdjustInfoHistoryController($scope, $state, $log, $resource,NgTableParams,Upload,authExpiredInterceptor,$timeout,$base64,ClaimAdjustInfo,CLAIM_TYPE,$filter,FORMAT_DATE,$window,GLOBAL_URL,ClaimRegistration,$stateParams,MyTask,$uibModal) {
		
		$scope.CLAIM_TYPE = CLAIM_TYPE;
		// init all data
		var param = $stateParams;
		
		var claimAdjustInfoHistoryCtr = this;
		claimAdjustInfoHistoryCtr.policyIsTPDAndRO1 = false;
		claimAdjustInfoHistoryCtr.claimCase  = {
			
		};
		
		claimAdjustInfoHistoryCtr.pendingNoticeGroupValid = [];
		claimAdjustInfoHistoryCtr.pendingNoticeGroupInvalid = [];
		
		
		claimAdjustInfoHistoryCtr.init = function() {
			var txnId = $base64.decode(param.txnId);
			ClaimAdjustInfo.loadAdjustInfoHistory({txnId:txnId},function(result){
				claimAdjustInfoHistoryCtr.claimCase = result;
				claimAdjustInfoHistoryCtr.originalDocList = claimAdjustInfoHistoryCtr.claimCase.docList;
				if(result.claimType == 'TPD' && result.poType == 'RO1') {
					claimAdjustInfoHistoryCtr.policyIsTPDAndRO1 = true;
				}
				angular.forEach(claimAdjustInfoHistoryCtr.claimCase.requestLetterList, function(requestLetter) {
					  if(requestLetter.valid!=null&&requestLetter.valid) {
						  claimAdjustInfoHistoryCtr.pendingNoticeGroupValid[requestLetter.pendingNoticeId] =true;
					  }
					  if(requestLetter.valid!=null&&!requestLetter.valid){
						  claimAdjustInfoHistoryCtr.pendingNoticeGroupInvalid[requestLetter.pendingNoticeId] = true;
						  requestLetter.invalid = true;
					  }
					});
				claimAdjustInfoHistoryCtr.requestLtrParams = new NgTableParams({
					 group: 'pendingNoticeId',
					 count :100000000
				},
				{
					counts: [],
					defaultSort: 'desc',
					dataset : claimAdjustInfoHistoryCtr.claimCase.requestLetterList      	
				});
				claimAdjustInfoHistoryCtr.docParams = new NgTableParams({
					count :100000000
				}, {
					 dataset: claimAdjustInfoHistoryCtr.originalDocList,
					 counts: []
				});
				
				ClaimRegistration.getDocumentByType({claimType:claimAdjustInfoHistoryCtr.claimCase.claimType},function(result){
					claimAdjustInfoHistoryCtr.documents = result;
				})
				
				claimAdjustInfoHistoryCtr.claimCase.registerDateStr = $filter('date')(claimAdjustInfoHistoryCtr.claimCase.registerDate, FORMAT_DATE);
				
				claimAdjustInfoHistoryCtr.claimCase.docCompletedDateStr = $filter('date')(claimAdjustInfoHistoryCtr.claimCase.docCompletedDate, FORMAT_DATE);
				
				claimAdjustInfoHistoryCtr.claimCase.eventDateStr = $filter('date')(claimAdjustInfoHistoryCtr.claimCase.eventDate, FORMAT_DATE);
				
				claimAdjustInfoHistoryCtr.claimCase.hopitalStartDateStr = $filter('date')(claimAdjustInfoHistoryCtr.claimCase.hopitalStartDate, FORMAT_DATE);
				
				claimAdjustInfoHistoryCtr.claimCase.hopitalEndDateStr = $filter('date')(claimAdjustInfoHistoryCtr.claimCase.hopitalEndDate, FORMAT_DATE);
			
				claimAdjustInfoHistoryCtr.taskInstanceParams= new NgTableParams({}, {
					 dataset: claimAdjustInfoHistoryCtr.claimCase.histories
				});
				claimAdjustInfoHistoryCtr.ackLettersParams= new NgTableParams({}, {
					 dataset: claimAdjustInfoHistoryCtr.claimCase.ackLetters
				});
			});
		}

		claimAdjustInfoHistoryCtr.agentInfo = function (){
			if(claimAdjustInfoHistoryCtr.claimCase&&claimAdjustInfoHistoryCtr.claimCase.agentCode&&claimAdjustInfoHistoryCtr.claimCase.agentName) {
				return claimAdjustInfoHistoryCtr.claimCase.agentCode + " - "+ claimAdjustInfoHistoryCtr.claimCase.agentName;
			}
		}
		claimAdjustInfoHistoryCtr.surgery = function(){
			if(claimAdjustInfoHistoryCtr.claimCase&&claimAdjustInfoHistoryCtr.claimCase.surgeryCode&&claimAdjustInfoHistoryCtr.claimCase.surgeryName) {
				return claimAdjustInfoHistoryCtr.claimCase.surgeryCode + " - "+ claimAdjustInfoHistoryCtr.claimCase.surgeryName;
			}
		}
		
		claimAdjustInfoHistoryCtr.taskInstanceParams= new NgTableParams({}, {
			 dataset: claimAdjustInfoHistoryCtr.claimCase.histories
		});
		
		claimAdjustInfoHistoryCtr.ackLettersParams= new NgTableParams({}, {
			 dataset: claimAdjustInfoHistoryCtr.claimCase.ackLetters
		});
		
		claimAdjustInfoHistoryCtr.viewLetter = function(letterFileLogId){
			$window.open(GLOBAL_URL+'ga/claims/request-letter/download/'+$base64.encode(letterFileLogId)+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
		}
		
		
		claimAdjustInfoHistoryCtr.requestLtrParams = new NgTableParams({
			page: 1
		},
		{
			defaultSort: 'desc',
			dataset :claimAdjustInfoHistoryCtr.claimCase.requestLetterList     	
		});
		
		
		claimAdjustInfoHistoryCtr.docParams = new NgTableParams({}, {
			 dataset: claimAdjustInfoHistoryCtr.originalDocList
		});
		
		claimAdjustInfoHistoryCtr.print =function (claimAdjustInfoId){
			$window.open(GLOBAL_URL +"ga/claims/gen-adjust-info-ack-letter/"+$base64.encode(claimAdjustInfoId)+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
		}
		
		claimAdjustInfoHistoryCtr.printLetter =function (ltrHistoryId){
			$window.open(GLOBAL_URL+'ga/claims/download-adjust-ack-letter/'+$base64.encode(ltrHistoryId)+'?access_token=' + authExpiredInterceptor.getToken(),"_blank");
		}
		
	}
})();
